import React, { useEffect, useState } from "react";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import FooterLinks from "../components/FooterLinks";
import bannerImage from "../assets/banner4.png";
import { Helmet } from "react-helmet-async";
import '../Site.css';
import '../Home.css';
import ScrollingBanner from "../components/scrollingBanner";


function Home() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    try {
      const user = localStorage.getItem("user");

      if (user) {
        const parsedUser = JSON.parse(user);
        if (parsedUser && parsedUser.Name) {
          setUserName(parsedUser.Name);
        }
      }
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
    }
  }, []);

    // <ScrollingBanner /> add under helmet when banner is needed

  return (
    <>
      <Helmet>
        <title>PharmPrepPro - Home</title>
      </Helmet>
      <BottomContainer>
        <Banner height="300px" width="100%" image={bannerImage} />

        

        <BodyContainer>
          <h1 className="white-text center-text-mobile">Welcome to PharmPrepPro</h1>
          <p className="white-text subtitle center-text-mobile">
            <strong><em>Your one-stop platform for pharmacy exam prep</em></strong>
          </p>

          <section>
          <h2 className="white-text" style={{ fontSize: "1.25rem" }}>
          At PharmPrepPro we specialize in 
          high-quality, exam-focused study tools designed to help pharmacy professionals succeed
          </h2>


            <h2 className="white-text" style={{ marginTop: "40px" }}>Why Choose Us</h2>
            <p className="white-text">Your trusted source for pharmacy exam success</p>

            <p className="white-text">
              Our content is created by <strong>Board Certified Pharmacists</strong> with extensive real-world and academic experience—ensuring every course and question is:
            </p>
            <ul className="white-text bullet-indent">
              <strong>
                <li>Accurate</li>
                <li>Up-to-date</li>
                <li>Aligned with exam standards</li>
              </strong>
            </ul>

            <p className="white-text" style={{ marginTop: "20px" }}>
              Whether you're preparing for the <strong>NAPLEX®</strong>, <strong>MPJE®</strong>, <strong>UMPJE®</strong> or state-specific exams, our:
            </p>
            <ul className="white-text bullet-indent">
              <strong>
                <li>Intuitive platform</li>
                <li>Targeted review materials</li>
                <li>Realistic practice exams</li>
              </strong>
            </ul>

            <p className="white-text" style={{ marginTop: "20px" }}>
              ...are built to boost your confidence—and your score.
            </p>

            <p className="white-text" style={{ marginTop: "40px" }}>
              <strong>No fluff.</strong><br />
              <strong>Just results-driven preparation that works.</strong>
            </p>
          </section>
        </BodyContainer>
      </BottomContainer>

      <FooterLinks />
      <Footer />
    </>
  );
}

export default Home;
